import { Route } from '@angular/router';
import { PAGE_TITLE_SUFFIX } from '../../app.constants';

import { UserRouteAccessService } from '../../shared';
import { DocumentComponent } from './document.component';

export const addDocumentRoute: Route = {
  path: 'historique/:id/document',
  component: DocumentComponent,
  data: {
      needAuthentication: true,
      pageTitle: `Ajout des documents complémentaires au dossier${PAGE_TITLE_SUFFIX}`
  },
  canActivate: [UserRouteAccessService]
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/requete/add-document/document.route.ts